import React, { Fragment, useEffect, useState, useMemo, useCallback } from "react";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner } from "reactstrap";
import moment from 'moment';
import 'moment-timezone';
import { Link } from "react-router-dom";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import { isEmpty } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";

import Flatpickr from "react-flatpickr";
import Select from "react-select";
import AsyncSelect from 'react-select/async';

// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { getCompany, resetCompanyState } from "../../../store/company/action";
import { getBranch, resetBranchState } from "../../../store/branch/action";
import { getEmployee, resetEmployeeState } from "../../../store/employee/action";
import { getVillage, resetVillageState } from "../../../store/village/action";
import { getAddress as onGetAddresss, addNewAddress as onAddNewAddress, updateAddress as onUpdateAddress, deleteAddress as onDeleteAddress, getAddressLoading } from "../../../store/address/action";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import ExportCSVModal from "../../../Components/Common/ExportCSVModal";

const Address = () => {
  const [modal, setModal] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const dispatch = useDispatch();

  const { addresses, isAddressCreated, isAddressSuccess, loading, error, companies, companyLoading, branches, branchLoading, employees, employeeLoading,
    villages, villageLoading } = useSelector((state) => ({
      addresses: state.Address.addresses,
      isAddressCreated: state.Address.isAddressCreated,
      isAddressSuccess: state.Address.isAddressSuccess,
      loading: state.Address.loading,
      companies: state.Company.companies,
      companyLoading: state.Company.loading,
      branches: state.Branch.branches,
      branchLoading: state.Branch.loading,
      employees: state.Employee.employees,
      employeeLoading: state.Employee.loading,
      villages: state.Village.villages,
      villageLoading: state.Village.loading,
      error: state.Address.error,
    }));

  const [addressList, setAddressList] = useState([]);
  const [address, setAddress] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [addrType, setAddrType] = useState();
  const [addressType, setAddresData] = useState([
    { label: "Domisili", value: 1, id: 1 },
    { label: "KTP", value: 2, id: 2 },
    { label: "Passport", value: 3, id: 3 },
    { label: "SIM", value: 4, id: 4 },
    { label: "Lainnya", value: 5, id: 5 }]);
  const [companyList, setCompanyList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [villageList, setVillageList] = useState([]);
  const [employeeList, setEmployeeList] = useState([]);

  const typeData = [
    {
      options: [
        { label: "Company", value: "company", id: 1 },
        { label: "Branch", value: "branch", id: 2 },
        { label: "Employee", value: "employee", id: 3 },
        { label: "Vendor", value: "vendor", id: 4 },
        { label: "Reseller", value: "reseller", id: 5 },
        { label: "Customer", value: "customer", id: 6 },
      ],
    }];

  const addressTypeData = [
    {
      options: addressType
    }];

  const [isSearch, setIsSearch] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isCompany, setIsCompany] = useState(true);
  const [isBranch, setIsBranch] = useState(false);
  const [isEmployee, setIsEmployee] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);

  const onClickDelete = (address) => {
    setAddress(address);
    setDeleteModal(true);
  };

  const handleDeleteAddress = () => {
    if (address) {
      dispatch(onDeleteAddress(address));
      setDeleteModal(false);
    }
  };

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  useEffect(() => {
    setAddressList(addresses);
  }, [addresses]);

  useEffect(() => {
    if (!isEmpty(addresses)) {
      setAddressList(addresses);
    }
  }, [addresses]);

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setAddressList([]);
      setActiveTab(tab);
      setAddrType(type);
      dispatch(onGetAddresss({ "type": type }));
    }
  };

  useEffect(() => {
    if (addresses && !addresses.length && !isSearch) {
      dispatch(onGetAddresss({ "type": "company" }));
    }
    setIsSearch(true);
  }, [dispatch, addresses, isSearch]);

  function handleEmployee(e) {
    if (e.length > 2) {
      dispatch(getEmployee({ title: e, type: "referral", status: 2 }));
    }
    return false;
  }

  useEffect(() => {
    if (!isEmpty(employees)) {
      var data = [];
      var opt = [];
      employees.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        const companyId = item.companyId;
        var obj = { label: name, value: id, companyId: companyId };
        opt.push(obj);
      })
      var option = { options: opt }
      data.push(option);
      setEmployeeList(data);
    }
  }, [employees]);

  function handleCompany(e) {
    if (e.length > 3) {
      const param = { "title": e, "status": 2 }
      dispatch(getCompany(param));
    }
    return false;
  }

  const promiseOptions = (e) => {
    if (!villageLoading) {
      dispatch(resetVillageState());
      setVillageList([]);
      if (e.length > 3) {
        dispatch(getVillage({ "title": e }));
      }
      return new Promise((resolve, reject) => {
        while (villageLoading);
        resolve(villageList);
      });
    }
  }

  useEffect(() => {
    if (!isEmpty(villages)) {
      var villageData = [];
      var opt = [];
      villages.forEach((item, key) => {
        const village_name = item.village_name;
        const id = item.id;
        const city_name = item.vc.city_name;
        const district_name = item.vd.district_name;
        const province_name = item.vp.province_name;
        var obj = { label: village_name + ', ' + district_name + ', ' + city_name + ' - ' + province_name, value: id };
        opt.push(obj);
      })
      var option = { options: opt }
      villageData.push(option);
      setVillageList(villageData);
    }
  }, [villages]);

  useEffect(() => {
    if (!isEmpty(companies)) {
      var data = [];
      var opt = [];
      (companies || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      })
      var option = { options: opt }
      data.push(option);
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    if (branches && !branches.length) {
      dispatch(getBranch({ type: "referral", status: 2 }));
    }
  }, [dispatch, branches]);

  function handleBranch(e) {
    if (e.length > 3) {
      const param = { "title": e, type: "referral", status: 2 }
      dispatch(getBranch(param));
    }
    return false;
  }

  useEffect(() => {
    if (!isEmpty(branches)) {
      var branchData = [];
      var opt = [];
      (branches || []).forEach((item, key) => {
        const branch_name = item.branch_name;
        const id = item.id;
        var obj = { label: branch_name, value: id };
        opt.push(obj);
      })
      var option = { options: opt }
      branchData.push(option);
      setBranchList(branchData);
    }
  }, [branches]);

  useEffect(() => {
    setAddress(addresses);
  }, [addresses]);

  useEffect(() => {
    if (!isEmpty(addresses)) {
      setAddress(addresses);
      setIsEdit(false);
    }
  }, [addresses]);

  useEffect(() => {
    setAddressList(addresses);
  }, [addresses]);

  useEffect(() => {
    if (!isEmpty(addresses)) setAddressList(addresses);
  }, [addresses]);

  const toggle = useCallback(() => {
    setEmployeeList([]);
    setBranchList([]);
    setCompanyList([]);
    if (modal) {
      setModal(false);
      setAddress(null);
      dispatch(resetEmployeeState());
      dispatch(resetBranchState());
      dispatch(resetCompanyState());
    } else {
      setModal(true);
    }
  }, [dispatch, modal]);

  const handleAddressClick = useCallback((arg) => {
    const address = arg;
    let type = [];
    addressType.forEach(t => {
      if (t.id === address.addressTypeId)
        type = t;
    });

    setAddress({
      id: address.id,
      address_name: address.address_name,
      address_code: address.address_code,
      isPrimary: address.isPrimary,
      description: address.description,
      addressTypeid: type.id,
      addressType: { label: type.label, value: type.value, id: type.id },
      village: { label: address.description, value: address.villageId },
    });

    setIsEdit(true);
    toggle();
  }, [addressType, toggle]);


  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      address_name: (address && address.address_name) || '',
      description: (address && address.description) || '',
      addressType: (address && address.addressType) || [],
      village: (address && address.village) || [],
      isPrimary: (address && address.isPrimary) || false,
    },
    validationSchema: Yup.object({
      address_name: Yup.string().required("Please Enter Address Name"),
      address_code: Yup.string().required("Please Enter Address Code"),
      village: Yup.object().required("Please Pick Village")
    }),
    onSubmit: (values) => {
      dispatch(getAddressLoading());
      if (isEdit) {
        const updateAddress = {
          id: address ? address.id : 0,
          address_name: values.address_name,
          description: values.description,
          addressType: values.addressType.id,
          isPrimary: values.isPrimary,
          villageId: values.village.value
        };
        dispatch(onUpdateAddress(updateAddress));
        validation.resetForm();
      } else {
        const newAddress = {
          address_name: values.address_name,
          description: values.description,
          addressType: values.addressType.id,
          isPrimary: values.isPrimary,
          villageId: values.village.value
        };
        if (addrType.value === "company" && values.company.value)
          newAddress.isCompany = values.company.value
        dispatch(onAddNewAddress(newAddress));
        validation.resetForm();
      }
      toggle();
    },
  });

  const checkedAll = () => {
    const checkall = document.getElementById("checkBoxAll");
    const ele = document.querySelectorAll(".dataCheckbox");

    if (checkall.checked) {
      ele.forEach((ele) => {
        ele.checked = true;
      });
    } else {
      ele.forEach((ele) => {
        ele.checked = false;
      });
    }
  };

  // Delete Multiple
  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeleteAddress(element.value));
    });
    checkall.checked = false;
  };

  const columns = useMemo(() => [
    {
      Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" onClick={() => checkedAll()} />,
      Cell: (cellProps) => {
        return <input type="checkbox" className="dataCheckbox form-check-input" value={cellProps.row.original.id} />;
      },
      id: '#',
    },
    {
      Header: "Nama",
      accessor: "address_name",
      filterable: true,
    },
    {
      Header: "Alamat",
      accessor: "description",
      filterable: true,
    },
    {
      Header: "Primary",
      filterable: true,
      Cell: (address) => (
        <>
          {handleAddressPrimary(address.row.original.isPrimary)}
        </>
      )
    },
    {
      Header: "Province",
      accessor: "av.vp.province_name",
      filterable: true,
    },
    {
      Header: "City",
      accessor: "av.vc.city_name",
      filterable: true,
    },
    {
      Header: "District",
      accessor: "av.vd.district_name",
      filterable: true,
    },
    {
      Header: "Village",
      accessor: "av.village_name",
      filterable: true,
    },
    {
      Header: "Zip",
      accessor: "av.zip",
      filterable: true,
    },
    {
      Header: " ",
      filterable: false,
      Cell: (cellProps) => {
        return (
          <div className="hstack gap-2 mt-4 mt-sm-0">
            <Link to="#" className="btn-icon btn btn-sm btn-light edit-item-btn"
              onClick={() => {
                const addressData = cellProps.row.original;
                handleAddressClick(addressData);
              }}>
              <i className="ri-edit-2-line fs-15"></i>
            </Link>
            <Link to="#" className="btn-icon btn btn-sm btn-soft-danger remove-item-btn"
              onClick={() => {
                const addressData = cellProps.row.original;
                onClickDelete(addressData);
              }}>
              <i className="ri-delete-bin-line fs-15 text-danger"></i>
            </Link>
          </div>
        );
      },
    }], [handleAddressClick]);

  const handleAddressPrimary = obj => {
    if (obj)
      return "Yes";
    else
      return "No"
  }


  const [filterDate, setFilterDate] = useState(null);

  const handleValidDate = date => {
    return moment(date, "YYYY/MM/DD").format("MMM D, YYYY");
  };

  const handleValidTime = (time) => {
    return moment(time, "YYYY/MM/DD").format('HH:mm');
  };

  //TABLE
  const { getTableProps, rows, getTableBodyProps, headerGroups, page, prepareRow, canPreviousPage, canNextPage, pageOptions, gotoPage, nextPage, previousPage, setPageSize, preGlobalFilteredRows, setGlobalFilter, state: { pageIndex, pageSize } } = useTable(
    {
      columns: columns,
      data: addressList,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: 0, pageSize: 10, selectedRowIds: 0,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState([]);
  const onChange = useAsyncDebounce((value) => { setGlobalFilter(value || undefined); }, 600);

  function handleFilter() {
    setActiveTab(addrType.id);
    let startat = '';
    let endat = '';
    let datearr = filterDate.split(' to ');
    if (datearr[1]) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }
    var type = addrType.value ? addrType.value : 'company';
    const param = {
      "title": searchValue,
      "startat": startat,
      "endat": endat,
      "type": type
    }
    dispatch(onGetAddresss(param));
  }

  document.title = "Addresss | Enterprise Resources Planning";
  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={addressList} />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeleteAddress} onCloseClick={() => setDeleteModal(false)} />
      <DeleteModal show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)} />
      <Container fluid>
        <BreadCrumb title="Addresss" pageTitle="Alamat" />
        <Row>
          <Col lg={12}>
            <Card id="addressList">
              <CardHeader className="card-header border-0">
                <div className="d-flex align-items-center">
                  <h5 className="card-title mb-0 flex-grow-1">
                    Address History &nbsp;{isLoading ? (
                      <>
                        <Spinner color="primary" type="grow" size={"sm"}> Loading... </Spinner>&nbsp;
                        <Spinner color="success" type="grow" size={"sm"}> Loading... </Spinner>&nbsp;
                      </>
                    ) : ""}
                  </h5>
                  <div className="flex-shrink-0">
                    <button type="button" className="btn btn-primary add-btn me-2" id="create-btn" onClick={() => { setAddress(""); setIsEdit(false); toggle(); }}>
                      <i className="ri-contacts-book-line me-1 align-bottom fs-14"></i> Tambah
                    </button>  <button type="button" className="btn btn-success me-1" onClick={() => setIsExportCSV(true)}>
                      <i className="ri-file-download-line me-1 align-bottom fs-14"></i>  Export
                    </button>  <button className="btn btn-soft-danger" onClick={() => setDeleteModalMulti(true)}>
                      <i className="ri-delete-bin-5-line me-1 align-bottom fs-15"></i> Delete</button>
                  </div>
                </div>
              </CardHeader>
              <CardBody className="pt-0">
                <div>
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist" >
                    <NavItem>
                      <NavLink className={classnames({ active: activeTab === "1" }, "fw-semibold")} onClick={() => { toggleTab("1", "company"); }} href="#">
                        <i className="ri-building-4-line me-1 align-bottom fs-14"></i>  Company
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink className={classnames({ active: activeTab === "2" }, "fw-semibold")} onClick={() => { toggleTab("2", "branch"); }} href="#">
                        <i className="ri-hotel-line me-1 align-bottom fs-14"></i>  Branch
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink className={classnames({ active: activeTab === "3" }, "fw-semibold")} onClick={() => { toggleTab("3", "employee"); }} href="#">
                        <i className="ri-account-circle-line me-1 align-bottom fs-14"></i>  Employee    </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink className={classnames({ active: activeTab === "4" }, "fw-semibold")} onClick={() => { toggleTab("4", "vendor"); }} href="#">
                        <i className="ri-truck-line me-1 align-bottom fs-14"></i>  Vendor
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink className={classnames({ active: activeTab === "5" }, "fw-semibold")} onClick={() => { toggleTab("5", "reseller"); }} href="#">
                        <i className="ri-store-3-line me-1 align-bottom fs-14"></i>  Reseller
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink className={classnames({ active: activeTab === "6" }, "fw-semibold")} onClick={() => { toggleTab("6", "customer"); }} href="#">
                        <i className="ri-customer-service-2-line me-1 align-bottom fs-14"></i>  Customer
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={2}>
                            <div className="me-2 mb-2 col-12">
                              <select className="form-select"
                                value={pageSize} onChange={onChangeInSelect}> {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>{pageSize}</option>
                                ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={4}>
                            <div className="search-box me-2 mb-2 d-inline-block col-12">
                              <input
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                                  gotoPage(0);
                                }}
                                id="search-bar-0" type="text" className="form-control search"
                                placeholder={`${count} Search...`} value={searchValue ?? ""} />
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={6} className="col-xxl-3">
                            <div className="search-box mb-2">
                              <Flatpickr className="form-control" id="datepicker-publish-input" placeholder="Select a date"
                                options={{
                                  mode: "range",
                                  dateFormat: "Y/m/d"
                                }}
                                onChange={(selectedDates, dateStr) => { setFilterDate(dateStr); }} /><i className="bx bx-calendar-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={4} className="col-xxl-2">
                            <div className="me-2 mb-2 col-12">
                              <Select
                                value={addrType}
                                placeholder="Select Status"
                                onChange={(e) => { setAddrType(e) }}
                                options={typeData}
                                name="addressType"></Select>
                            </div>
                          </Col>
                          <Col sm={2}>
                            <div>
                              <button type="button" className="btn btn-light w-100" onClick={() => { handleFilter(); }}>              <i className="ri-search-line me-1 align-bottom fs-14"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>

                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>

                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button color="light" onClick={previousPage} disabled={!canPreviousPage}> {"<"} </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">Page    {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button className="btn btn-light" onClick={nextPage} disabled={!canNextPage}>{">"}</Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="md">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit ? "Edit Address" : "Add Address"}
                  </ModalHeader>
                  <Form onSubmit={(e) => { e.preventDefault(); validation.handleSubmit(); return false; }}>
                    <ModalBody>
                      <div className="row">
                        <div className="col-lg-12">
                          {!isEdit ? (
                            <div className="mb-3">
                              <Label htmlFor="active-status" className="form-label">Type</Label>
                              <Input name="addressType" type="select" className="form-select"
                                onChange={(e) => {
                                  validation.setFieldValue("addressType", e);
                                  setIsCompany(false);
                                  setIsBranch(false);
                                  setIsEmployee(false);

                                  if (e.target.value === "company") setIsCompany(true);
                                  if (e.target.value === "branch") setIsBranch(true);
                                  if (e.target.value === "employee") setIsEmployee(true);
                                }}
                                onBlur={validation.handleBlur}
                                invalid={validation.touched.type && validation.errors.type ? true : false}>
                                {typeData.map((item, key) => (
                                  <React.Fragment key={key}>
                                    {item.options.map((item, key) => (<option value={item.value} key={key}>{item.label}</option>))}
                                  </React.Fragment>
                                ))}
                              </Input>
                            </div>
                          ) : ""}
                          {isCompany && !isEdit ? (
                            <div className="mb-3">
                              <Label htmlFor="company" className="form-label">Company {companyLoading ? (<Spinner color="primary" size="sm"> Loading... </Spinner>) : ""} </Label>
                              <Select name="company"
                                value={validation.values.company}
                                placeholder="Enter Company"
                                onChange={(e) => { validation.setFieldValue("company", e); }}
                                onInputChange={(e) => { handleCompany(e) }}
                                options={companyList}
                                invalid={validation.touched.company && validation.errors.company ? true : false}></Select>
                              {validation.touched.company && validation.errors.company ? (
                                <p className="text-danger" type="invalid">{validation.errors.company}</p>
                              ) : null}
                            </div>
                          ) : ""}
                          {isBranch && !isEdit ? (
                            <div className="mb-3">
                              <Label htmlFor="branch" className="form-label">Branch {branchLoading ? (<Spinner color="primary" size="sm"> Loading... </Spinner>) : ""} </Label>
                              <Select name="branch"
                                value={validation.values.branch}
                                placeholder="Pilih Proyek / Cabang"
                                onChange={(e) => { validation.setFieldValue("branch", e); }}
                                onInputChange={(e) => { handleBranch(e) }}
                                options={branchList}
                                invalid={validation.touched.branch && validation.errors.branch ? true : false}></Select>
                              {validation.touched.branch && validation.errors.branch ? (
                                <p className="text-danger" type="invalid">{validation.errors.branch}</p>
                              ) : ""}
                            </div>
                          ) : null}

                          {isEmployee && !isEdit ? (
                            <div className="mb-3">
                              <Label htmlFor="employee" className="form-label">Employee {employeeLoading ? (<Spinner color="primary" size="sm"> Loading... </Spinner>) : ""} </Label>
                              <Select name="employee"
                                value={validation.values.employee}
                                placeholder="Pilih Proyek / Cabang"
                                onChange={(e) => { validation.setFieldValue("employee", e); }}
                                onInputChange={(e) => { handleEmployee(e) }}
                                options={employeeList}
                                invalid={validation.touched.employee && validation.errors.employee ? true : false}></Select>
                              {validation.touched.employee && validation.errors.employee ? (
                                <p className="text-danger" type="invalid">{validation.errors.employee}</p>
                              ) : ""}
                            </div>
                          ) : null}

                          <div className="mb-3">
                            <Label htmlFor="village" className="form-label">City {villageLoading ? (<Spinner color="primary" size="sm"> Loading... </Spinner>) : ""} </Label>
                            <AsyncSelect name="village"
                              value={validation.values.village}
                              placeholder="Enter City"
                              onChange={(e) => {
                                validation.setFieldValue("village", e);
                              }}
                              cacheOptions
                              loadOptions={promiseOptions}
                              invalid={validation.touched.village && validation.errors.village ? true : false}></AsyncSelect>
                            {validation.touched.village && validation.errors.village ? (
                              <p className="text-danger" type="invalid">{validation.errors.village}</p>
                            ) : ""}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="addressname-field" className="form-label"> Title </Label>
                            <Input name="address_name" id="addressname-field" className="form-control" placeholder="Isi Nama" type="text"
                              validate={{ required: { value: true }, }}
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.address_name ?? ""}
                              invalid={validation.touched.address_name && validation.errors.address_name ? true : false} />
                            {validation.touched.address_name && validation.errors.address_name ? (
                              <FormFeedback type="invalid">{validation.errors.address_name}</FormFeedback>
                            ) : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="addressType" className="form-label">Address Type</Label>
                            <Input name="addressType" type="select" className="form-select"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.status || "1"}>
                              {addressTypeData.map((item, key) => (
                                <React.Fragment key={key}>
                                  {item.options.map((item, key) => (<option value={item.value} key={key}>{item.label}</option>))}
                                </React.Fragment>
                              ))}
                            </Input>
                          </div>
                          <div className="mb-3">
                            <Input name="isPrimary" id="isPrimary-field" className="form-check-input" type="checkbox"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              checked={validation.values.isPrimary} /> &nbsp;
                            <Label htmlFor="isPrimary-field" className="form-label">Primary Address</Label>
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="des-field" className="form-label">Address Detail</Label>
                            <Input name="description" id="des-field" className="form-control" placeholder="Isi Nama Jalan" type="textarea"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.description ?? ""} />
                          </div>
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button type="button" className="btn btn-light" onClick={() => { setModal(false); }}> Close </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">
                              {!!isEdit ? "Update" : "Add Address"}
                            </span>
                            {loading ? (<Spinner size="sm" className="flex-shrink-0" role="status"> Loading... </Spinner>) : ""}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>

              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div >
  );
};

export default Address;


